export const GlitchText = ({ children, className = "" }) => (
  <span className={`glitch ${className}`} data-text={children}>
    {children}
  </span>
);

export default GlitchText;
